import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Mixpanel from 'helpers/Mixpanel.js';
import {
  SideNav,
  SideItem,
  StyledItemsContainer,
  StyledCompany,
  NavProductList,
} from '@bit/knotchinc.web-react-components.side-nav';
import AdvancedSearchView from 'components/Pages/AdvancedSearch/AdvancedSearchView.jsx';
import { TOGGLE_ADVANCED_SEARCH } from 'components/Pages/AdvancedSearch/actions.js';
import { TOGGLE_COMING_SOON_MODAL } from 'components/Pages/Home/actions.js';
import {
  ComingSoonContentSharingModal,
  ComingSoonEmailAlertsModal,
  ComingSoonInsightsExportModal,
} from 'components/Modals/ComingSoonModals/';
import AccountDropDown from './AccountDropDown.jsx';
import { KIcon, LibraryIcon, PowerSearchIcon, ReportIcon, EntityCatalogueIcon } from './styled.js';

class BlueprintNav extends React.Component {
  render() {
    const {
      products,
      userEntity,
      isModalOpen,
      toggleAdvancedSearchModal,
      isCSContentModalOpen,
      isCSAlertsModalOpen,
      isCSExportModalOpen,
      toggleComingSoonModal,
      isKnotchAdmin,
    } = this.props;

    let entityCatalogueLink;

    if (userEntity) {
      const { name, public_id, type } = userEntity;
      entityCatalogueLink = (
        <SideItem
          icon={<EntityCatalogueIcon />}
          onClick={() => { Mixpanel.track(`Clicked ${name} Library on Sidebar`); }}
          Component={NavLink}
          url={`/blueprint/${type}/${public_id}`}
          name={`${name} Catalogue`}
        />
      );
    }

    return (
      <SideNav product="blueprint">
        <AdvancedSearchView isOpen={isModalOpen} close={() => toggleAdvancedSearchModal()} />
        <ComingSoonContentSharingModal isOpen={isCSContentModalOpen} close={() => toggleComingSoonModal('comingSoonContentSharing')} />
        <ComingSoonEmailAlertsModal isOpen={isCSAlertsModalOpen} close={() => toggleComingSoonModal('comingSoonEmailAlerts')} />
        <ComingSoonInsightsExportModal isOpen={isCSExportModalOpen} close={() => toggleComingSoonModal('comingSoonInsightsExport')} />
        <StyledCompany>
          <SideItem icon={<KIcon />} Component={NavLink} url="/blueprint" name="Blueprint" onClick={() => { Mixpanel.track('Clicked Home button'); }} />
          {isKnotchAdmin && process.env.version && <SideItem Component="div" name={`[dev] ${process.env.version}`} />}
        </StyledCompany>
        <StyledItemsContainer>
          <SideItem
            icon={<LibraryIcon />}
            Component={NavLink}
            url="/blueprint/library"
            onClick={() => { Mixpanel.track('Clicked Library on Sidebar'); }} name="Library"
          />
          {userEntity && entityCatalogueLink}
          <SideItem
            icon={<PowerSearchIcon />}
            onClick={() => {
              Mixpanel.track('clicked Advanced Search on Sidebar');
              return toggleAdvancedSearchModal();
            }}
            url="/blueprint/advanced_search"
            name="Advanced Search"
          />
          <SideItem
            Component={NavLink}
            icon={<ReportIcon />}
            onClick={() => { Mixpanel.track('clicked Reports on Sidebar'); }}
            url="/blueprint/reports"
            name="Reports"
          />
        </StyledItemsContainer>
        <NavProductList products={products} current="blueprint" />
        <AccountDropDown products={products} />
      </SideNav>
    );
  }
}

const mapStateToProps = ({
  Account: {
    isKnotchAdmin,
    isAccountAdmin,
    userEntity,
    data: { products },
  },
  AdvancedSearch: { isModalOpen },
  Home: {
    isModalToggled: {
      comingSoonContentSharing: isCSContentModalOpen,
      comingSoonEmailAlerts: isCSAlertsModalOpen,
      comingSoonInsightsExport: isCSExportModalOpen,
    },
  },
}) => ({
  isAccountAdmin,
  isKnotchAdmin,
  userEntity,
  products,
  isModalOpen,
  isCSContentModalOpen,
  isCSAlertsModalOpen,
  isCSExportModalOpen,
});

const mapDispatchToProps = (dispatch) => ({
  toggleAdvancedSearchModal: () => dispatch({ type: TOGGLE_ADVANCED_SEARCH }),
  toggleComingSoonModal: modal => dispatch({ type: TOGGLE_COMING_SOON_MODAL, modal }),
});

export default connect(mapStateToProps, mapDispatchToProps)(BlueprintNav);
